import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42bf68c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "badge-heading" }
const _hoisted_2 = {
  key: 1,
  class: "badge-detail-container"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "stats" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, " ", -1))
const _hoisted_7 = { class: "month" }
const _hoisted_8 = { class: "number" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Last 30 Days", -1))
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "All Time Total", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, " ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lottie = _resolveComponent("Lottie")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.animationData)
      ? (_openBlock(), _createBlock(_component_Lottie, {
          key: 0,
          "class-name": "bg-img-container",
          "animation-data": _ctx.animationData
        }, null, 8, ["animation-data"]))
      : _createCommentVNode("", true),
    (_ctx.scorecard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.badgeLabel), 1),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.pastMonthCount), 1),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.totalCount), 1),
                _hoisted_12
              ]),
              _hoisted_13
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}